// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__73HUw","toggleWrap":"styles_toggleWrap__20gA7","content":"styles_content__1Yd_Y","selectAreaCode":"styles_selectAreaCode__1dRC8"};